module.exports = __webpack_public_path__ + "img/diaodusiji.c83d166d.png";